var map = {
	"./ill1-academia.svg": 637,
	"./ill1-business.svg": 638,
	"./ill1.svg": 639,
	"./moneyback.png": 160,
	"./moneyback@2x.png": 161,
	"./satisfaction@2x.png": 73,
	"./thumb.svg": 640
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 159;